<template>
    <div class="Live">
        <mNav :msg="msg" :IsHome="true"></mNav>
        <div class="nav_qie">
            <van-row type="flex" justify="space-around">
                <van-col span="6">
                    <van-button type="info" plain size="mini" color="#3277BC">实时成绩</van-button>
                </van-col>
                <van-col span="6">
                    <van-button type="info" plain size="mini" color="#3277BC" @click="handleGameResult">赛事成绩</van-button>
                </van-col>
            </van-row>
        </div>

        <div class="liveList" >
            <van-list
                :finished="finished"
                offset="0"
                finished-text="没有更多了"
                v-if="LiveListNew && LiveListNew.length > 0"
                >
                <ul class="ll_box">
                    <li class="list_li" v-for="(i,index) in LiveListNew" :key="index">
                        <div class="list_li_top">
                            <div class="list_li_time">{{i.StartTime}}</div>
                            <div class="list_li_txt abs">{{i.MatchName}}</div>
                            <div class="list_li_cout">{{i.CourtNum}}</div>
                        </div>
                        <div class="list_li_center">
                            <div class="list_li_Home" >{{i.ADelegationLongName}}</div>
                            <!-- <div class="list_li_Home_point">【{{i.MatchScoreLeft}}】{{i.Results[0].SetScoreLeft ?}}</div> -->
                            <div class="list_li_Home_point">【{{i.MatchScoreLeft}}】{{i.F_PlayerRegTypeID == 3 ? i.Results[i.TeamCurrentSet -1].SetScoreLeft: ''}}</div>
                            <div class="list_li_txt_1">VS</div>
                            <!-- <div class="list_li_Home_point">{{i.Results[0].SetScoreRight}}【{{i.MatchScoreRight}}】</div> -->
                            <div class="list_li_Home_point">{{i.F_PlayerRegTypeID == 3 ? i.Results[i.TeamCurrentSet -1].SetScoreRight : ''}}【{{i.MatchScoreRight}}】</div>
                            <div class="list_li_Away"> {{i.BDelegationLongName}}</div>
                        </div>
                        
                        <div class="list_li_btm" v-if="i.F_PlayerRegTypeID == 3 ">
                            <div class="team_name">
                                <p>{{i.Results[i.TeamCurrentSet -1].PlayerA1}}</p>
                                <p>{{i.Results[i.TeamCurrentSet -1].PlayerA2}}</p>
                            </div>
                            <div class="CurrentScore">
                                <span>{{i.CurrentScoreLeft}}</span>
                            </div>
                            <div class="when_time">
                                {{i.Duration}}
                            </div>
                            <div class="CurrentScore">
                                <span>{{i.CurrentScoreRight}}</span>
                            </div>
                            <div class="team_name">
                                <p>{{i.Results[i.TeamCurrentSet -1].PlayerB1}}</p>
                                <p>{{i.Results[i.TeamCurrentSet -1].PlayerB2}}</p>
                            </div>
                        </div>

                        <div class="list_li_btm" v-if="i.F_PlayerRegTypeID != 3">
                            <div class="team_name">
                                <p>{{i.Results[0].PlayerA1}}</p>
                                <p>{{i.Results[0].PlayerA2}}</p>
                            </div>
                            <div class="CurrentScore">
                                <span>{{i.CurrentScoreLeft}}</span>
                            </div>
                            <div class="when_time">
                                {{i.Duration}}
                            </div>
                            <div class="CurrentScore">
                                <span>{{i.CurrentScoreRight}}</span>
                            </div>
                            <div class="team_name">
                                <p>{{i.Results[0].PlayerB1}}</p>
                                <p>{{i.Results[0].PlayerB2}}</p>
                            </div>
                        </div>

                        
                        <div class="set_score" :style="{'width':'auto','background':'none'}"
                        v-for="(j,indexs) in i.Results" :key="indexs">
                            <div v-if="i.F_PlayerRegTypeID == 3 && i.TeamCurrentSet==j.SetNum">
                                <span v-if="j.A1 != undefined">{{ j.A1 +'-' + j.B1}}<i v-if="j.A2 != undefined">,</i></span>
                                <span v-if="j.A2 != undefined">{{ j.A2 +'-' + j.B2}}<i v-if="j.A3 != undefined">,</i></span>
                                <span v-if="j.A3 != undefined">{{ j.A3 +'-' + j.B3}}<i v-if="j.A4 != undefined">,</i></span>
                                <span v-if="j.A4 != undefined">{{ j.A4 +'-' + j.B4}}<i v-if="j.A5 != undefined">,</i></span>
                                <span v-if="j.A5 != undefined">{{ j.A5 +'-' + j.B5}}<i v-if="j.A6 != undefined">,</i></span>
                                <span v-if="j.A6 != undefined">{{ j.A6 +'-' + j.B6}}<i v-if="j.A7 != undefined">,</i></span>
                                <span v-if="j.A7 != undefined">{{ j.A7 +'-' + j.B7}}</span>
                            </div>
                            <div  v-if="i.F_PlayerRegTypeID != 3">
                                <span v-if="j.A1 != undefined">{{ j.A1 +'-' + j.B1}}<i v-if="j.A2 != undefined">,</i></span>
                                <span v-if="j.A2 != undefined">{{ j.A2 +'-' + j.B2}}<i v-if="j.A3 != undefined">,</i></span>
                                <span v-if="j.A3 != undefined">{{ j.A3 +'-' + j.B3}}<i v-if="j.A4 != undefined">,</i></span>
                                <span v-if="j.A4 != undefined">{{ j.A4 +'-' + j.B4}}<i v-if="j.A5 != undefined">,</i></span>
                                <span v-if="j.A5 != undefined">{{ j.A5 +'-' + j.B5}}<i v-if="j.A6 != undefined">,</i></span>
                                <span v-if="j.A6 != undefined">{{ j.A6 +'-' + j.B6}}<i v-if="j.A7 != undefined">,</i></span>
                                <span v-if="j.A7 != undefined">{{ j.A7 +'-' + j.B7}}</span>
                            </div>
                            
                        </div>
                        
                    </li>
                </ul>
                
            </van-list>
            <van-empty v-else description="暂无进行中的比赛。。。" />
        </div>

    </div>
</template>

<script>
import mNav from "@/components/mNav.vue";
import LiveList from '@/assets/common/ResultList.json';
import http from '@/assets/js/http.js';
export default {
    name: "Live",
    components: {
        mNav,
    },
    data() {
        return {
            msg: sessionStorage.SportName,
            list: [],
            loading: false,
            finished: false,
            LiveList: [],
            LiveListNew: [],
            timer: null,
        }
    },
    mounted() {

        this.onLoad();

        this.timer = setInterval(() => {
            this.onLoad();
        }, 1000*5);
        console.log(this.LiveList)
    },
    beforeDestroy(){
        clearInterval(this.timer);        
        this.timer = null;
    },
    methods: {
        onLoad() {
            // this.LiveListNew = this.LiveList.JSONDate;
            http.GetFile('/Sports/TTE/'+sessionStorage.SportCode+'/Live.json?v='+Math.random()).then(res=>{//根据sportcode获取实时成绩地址
                // console.log(res)
                // this.sportListNew = res.JsonData;
                // this.sportList = res;
                this.LiveList = res;
            
            let newArr = [];
            newArr = this.LiveList.JsonData.filter(function(el){
                return el.F_MatchStatusID == 50;
            })
            console.log(newArr);
            this.LiveListNew = newArr;
            // this.LiveListNew = this.LiveList.JsonData;
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
            //     for (let i = 0; i < 10; i++) {
            //         this.list.push(this.list.length + 1);
            //     }

            //     // 加载状态结束
                this.loading = false;

            //     // 数据全部加载完成
            //     if (this.list.length >= 40) {
            //         this.finished = true;
            //     }
            }, 1000);
            
        })
        },
        handleGameResult(){//点击赛事成绩c
            // 生成随机数
            let randomNum = Math.random(); // 这里的范围根据需求进行调整
            this.$router.push({
                 path: '/GameResult', 
                 query: { v: randomNum }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
    $bgColor: #3277BC;
    .Live{
        font-size: 0.24rem;
    }
    .nav_qie{
        font-size: 0.3rem;
        line-height: 0.3rem;
        text-align: center;
        padding: 0.15rem 0.8rem;
    }
    .liveList{
        padding: 0.2rem;
    }
    .ll_box{
        width: 100%;
        .list_li{
            padding: 0.1rem;
            border: 1px solid $bgColor;
            border-radius: 0.1rem;
            font-size: 0.2rem;
            text-align: center;
            margin-bottom: 0.1rem;
            .list_li_top{
                width: 100%;
                display: flex;
                position: relative;
                .list_li_time{
                    width: 15%;
                    height: 0.5rem;
                    // background: rgb(255, 136, 3);
                    border: 1px solid $bgColor;
                    border-radius: 0.5rem;
                    font-weight: bold;
                    line-height: 0.5rem;
                }
                .list_li_txt{
                    flex: 1;
                    font-weight: bold;
                    line-height: 0.5rem;
                    font-size: 0.3rem;
                }
                .list_li_cout{
                    width: 0.5rem;
                    height: 0.5rem;
                    font-size: 0.36rem;
                    border-radius: 50%;
                    background: $bgColor;
                    font-weight: bold;
                    line-height: 0.5rem;
                    color: white;
                    position: absolute;
                    // left: 0;
                    right: 0;
                }
                .abs{
                    position: absolute;
                    left: 0;
                    right: 0;
                }
            }
            .list_li_center{
                width: 100%;
                display: flex;
                font-size: 0.3rem;
                margin-top: 0.15rem;
                .list_li_Home{
                    width: 30%;
                    // height: 0.5rem;
                    // background: rgb(255, 136, 3);
                    // border-radius: 0.5rem;
                    line-height: 0.5rem;
                    white-space: nowrap; /* 不换行 */
                    overflow: hidden; /* 溢出部分隐藏 */
                    text-overflow: ellipsis; /* 显示省略号 */
                }
                .list_li_Home_point{
                    width: 19%;
                }
                .list_li_txt_1{
                    width: 14%;
                    line-height: 0.5rem;
                }
                .list_li_Away{
                    width: 30%;
                    // height: 0.5rem;
                    // border-radius: 50%;
                    // background: rgb(165, 58, 58);
                    line-height: 0.5rem;
                    white-space: nowrap; /* 不换行 */
                    overflow: hidden; /* 溢出部分隐藏 */
                    text-overflow: ellipsis; /* 显示省略号 */
                }
            }
            .list_li_btm{
                width: 100%;
                display: flex;
                font-size: 0.3rem;
                justify-items: center;
                align-items: center;
                margin-top: 0.15rem;
                .team_name{
                    width: 25%;
                    p{
                        white-space: nowrap; /* 不换行 */
                        overflow: hidden; /* 溢出部分隐藏 */
                        text-overflow: ellipsis; /* 显示省略号 */
                    }
                }
                .CurrentScore{
                    width: 18%;
                    font-size: 0.6rem;
                }
                .when_time{
                    width: 14%;
                    margin: 0.08rem auto;
                    line-height: 0.35rem;
                    // background: #3277BC;
                    color: $bgColor;
                    align-self: flex-end;
                    font-size: 0.24rem;
                    font-weight: bold;
                }
            }
            .set_score{
                margin-top: 0.15rem;
                font-size: 0.26rem;
            }
            
        }
    }
</style>